module.exports = __webpack_public_path__ + "fonts/GT-Cinetype-Bold.8dc81437.woff2";